<swiper-container pagination="true">
    <swiper-slide>
        <div class="slide-custom">
            <img src="/assets/images/pro-features-slides/colors2.png" width="100" height="100" alt="customize">
            <h4 class="slide-title">{{ 'PRO_SWIPER_CUSTOM_PORTAL_TITLE' | translate }}</h4>
            <p class="slide-subtitle">{{ 'PRO_SWIPER_CUSTOM_PORTAL_DESC' | translate }}</p>
        </div>
    </swiper-slide>
    <swiper-slide>
        <div class="slide-custom">
            <img src="/assets/images/pro-features-slides/custom-form.png" width="100" height="100" alt="customform">
            <h4>{{ 'PRO_SWIPER_CUSTOM_FORMS_TITLE' | translate }}</h4>
            <p class="slide-subtitle">{{ 'PRO_SWIPER_CUSTOM_FORMS_DESC' | translate }}</p>
        </div>
    </swiper-slide>
    <swiper-slide>
        <div class="slide-custom">
            <img src="/assets/images/pro-features-slides/integration.png" width="100" height="100" alt="prescription">
            <h4>{{ 'PRO_SWIPER_INSOLES_INTEGRATION_TITLE' | translate }}</h4>
            <p class="slide-subtitle">{{ 'PRO_SWIPER_INSOLES_INTEGRATION_DESC' | translate }}</p>
        </div>
    </swiper-slide>
</swiper-container>